module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-head"
  }, [_c('node-label', {
    staticClass: "head-text",
    attrs: {
      "node": _vm.node
    }
  }, [(_vm.articleType === 'opinion') ? [_c('SpeechBalloonLabel', {
    attrs: {
      "slot": "speechBalloonLabel",
      "node": _vm.node,
      "size": "large",
      "mainComponent": "body-head__node-label",
      "shadow": ""
    },
    slot: "speechBalloonLabel"
  })] : _vm._e()], 2), (_vm.title) ? _c('div', {
    staticClass: "head-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.node.subheading) ? _c('div', {
    staticClass: "head-subheading"
  }, [_vm._v(_vm._s(_vm.node.subheading))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d342b8d0","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/fields/BodyHead.vue
// module id = 1785
// module chunks = 1